import VerifyEmailMediaContainer from './VerifyEmailMediaContainer';

export default VerifyEmailMediaContainer;
